import i18n from 'i18next';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { SlideInterface } from '@tencent/docs-api';
import { IElementNode } from '../../slide-content-enumerator/enumerator-types.interface';
import { BaseAnalyzer } from '../base/base-analyzer';

interface IOutsideElement {
    pageIndex?: number,
    element?: IElementBaseModel,
}

type IResult = SlideInterface.CheckResultItem;

export class MachineOutsideAnalyzer extends BaseAnalyzer<IResult> {
    private title = i18n.t('元素出界检测');
    private description = i18n.t('检查元素是否出现在页面之外');
    private level = 'error' as const;
    private anchorType = 'element' as const;

    private outsideElements = new Map<string, IOutsideElement>();

    public constructor(private uiDataService: IUiDataService) {
        super();
    }

    public onPresentationStart(): void {
        this.outsideElements = new Map<string, IOutsideElement>();
    }

    public onElement(node: IElementNode): void {
        const { slideWidth, slideHeight } = this.uiDataService.presentation.props;
        const { element } = node;
        const boundingRect = element.getFrame().boundingRectOnSlide();
        if (boundingRect.left > slideWidth) {
            this.addOutsideElement(node);
            return;
        }
        if (boundingRect.top > slideHeight) {
            this.addOutsideElement(node);
            return;
        }
        if (boundingRect.left + boundingRect.width < 0) {
            this.addOutsideElement(node);
            return;
        }
        if (boundingRect.top + boundingRect.height < 0) {
            this.addOutsideElement(node);
            return;
        }
    }

    public async calculateResult(): Promise<IResult> {
        const passed = this.outsideElements.size <= 0;
        if (passed) {
            return { passed, title: this.title, description: this.description };
        }
        const errorArray = Array.from(this.outsideElements.values());
        const errorMessages: SlideInterface.CheckErrorMessage[] = errorArray.map(item => ({
            level: this.level,
            anchorType: this.anchorType,
            anchor: item.element,
            description: i18n.t(`元素${item.element?.name}出界`),
        }));
        return { passed, title: this.title, description: this.description, errorMessages };
    }

    private addOutsideElement(node: IElementNode) {
        const { element, slideNode } = node;
        this.outsideElements.set(element.id ?? '', {
            pageIndex: slideNode.slideIndex,
            element,
        });
    }
}
